export default __webpack_public_path__ + "static/media/clockpurple.68b562dd.svg";